export const BLOGS_LIST = "BLOGS_LIST";
export const BLOGS_DETAILS = "BLOGS_DETAILS";